import type { CreatorsInListDTO } from '@/entities/saved-creators-list';

const MOCK_EMAIL_RATIO = 0.6;
const MOCK_EMAIL_BUCKET_SIZE = 10;

function buildMockCreatorEmail(creator: CreatorsInListDTO): string {
  const emailName = (creator.username || creator.id)
    .replace(/^@/, '')
    .replace(/[^a-z0-9.]/gi, '')
    .toLowerCase();

  return `${emailName || creator.id}@gmail.com`;
}

function shouldUseMockEmail(index: number): boolean {
  return index % MOCK_EMAIL_BUCKET_SIZE < MOCK_EMAIL_BUCKET_SIZE * MOCK_EMAIL_RATIO;
}

export function enrichSavedListCreatorsWithMockEmails(
  creators: CreatorsInListDTO[],
): CreatorsInListDTO[] {
  return creators.map((creator, index) => {
    if (creator.email) {
      return creator;
    }

    return {
      ...creator,
      email: shouldUseMockEmail(index) ? buildMockCreatorEmail(creator) : null,
    };
  });
}
